import { usePrevious } from '@solinkcorp/solink-components';
import { useWindowVisibility } from '@solinkcorp/utils/hooks';
import { useEffect, useRef } from 'react';
import { type PlaybackController } from './PlaybackController';

/**
 * Pause playback when the window is hidden.
 */
export function usePauseOnWindowHidden(playbackController: PlaybackController | undefined) {
  const previousRequestedPauseState = useRef(playbackController?.isPaused() || false);
  const windowVisible = useWindowVisibility();
  const previousWindowVisible = usePrevious(windowVisible);

  useEffect(() => {
    if (windowVisible === previousWindowVisible) {
      return;
    }

    if (!windowVisible) {
      previousRequestedPauseState.current = playbackController?.isPaused() || false;
      playbackController?.togglePaused(true);
    } else {
      playbackController?.togglePaused(previousRequestedPauseState.current);
    }
  }, [windowVisible, previousWindowVisible, playbackController]);
}
